import { Component, OnInit, OnDestroy, TemplateRef, ViewContainerRef, Input } from '@angular/core';
import { ManageService } from '../../../services/manage.service';
import { CommonService } from '../../../services';
import { Router, ActivatedRoute } from '@angular/router';
import { BehaviorSubject, combineLatest, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { CancelContent, CSPModifySubscriptionViewModel, GetCSPSubscription, MCEUpgradeModel, ProductTerm, RefundableDetails, RefundableQuantity, ScheduledNextTermInstructions, CSPModifySubscriptionResponse, CSPSubscriptions } from '../../../models/csp.model';
import { ConfirmNCESubscriptionComponent } from '../../../popup-collection/confirm-nce-subscription/confirm-nce-subscription.component';
import { format } from 'date-fns';
import { AbstractControl, FormBuilder, FormControl } from '@angular/forms';
import { MnpIdAipiResponse } from '../../../models/api-response.model';
import { ConfirmSubscriptionComponent } from '../../../popup-collection/confirm-subscription/confirm-subscription.component';
import { FinishSubscriptionComponent } from '../../../popup-collection/finish-subscription/finish-subscription.component';
import { MatDialog } from '@angular/material/dialog';
import { PanelService } from '../../../services/panel.service';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { CurrentUserModel } from '../../../models/account-ledger.model';
import { AuthService } from '../../../services/auth.service';
import { SimpleMsgPopupComponent } from '../../../popup-collection/simple-msg/simple-msg-popup.component';
import { Location } from '@angular/common';
import { ConfirmMASSubCreationPopup } from '../../../popup-collection/comfirm-mas-sub-creation-popup/comfirm-mas-sub-creation-popup.component';
import { ADKDetailsViewModel } from '../../../models/adk-details-view.model';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';

@Component({
  selector: 'app-manage-azure-subscription',
  templateUrl: './manage-azure-subscription.component.html',
  styleUrls: ['./manage-azure-subscription.component.css'],
  providers: [DatePipe]
})
export class ManageAzureSubscriptionComponent implements OnInit, OnDestroy {

  public sideMenu: sideMenuElement[] = [
    {
      tabIndex: 0,
      key: 'SubscriptionDetails',
      displayName: 'Subscription Details',
      disabled: false,
      refreshingFlag: false
    },
    {
      tabIndex: 1,
      key: 'ManageService',
      displayName: 'Manage Service',
      disabled: false,
      refreshingFlag: false
    },
    {
      tabIndex: 2,
      key: 'FraudNotifications',
      displayName: 'Fraud Notifications',
      disabled: false,
      refreshingFlag: false
    },
    {
      tabIndex: 3,
      key: 'BudgetAlerts',
      displayName: 'Budgets & Alerts',
      disabled: false,
      refreshingFlag: false
    }
     /* { 
       tabIndex: 4,
       key: 'Subscriptions',
       displayName: 'Subscriptions',
       disabled: true,
       refreshingFlag: false
       
     }  */
  ]
  filterResultArr: any;
  searchField: string;  
  public currentMenuIndex = 0;
  private _details = new BehaviorSubject<ADKDetailsViewModel>(null);
  private _azureEntitlements = new BehaviorSubject<SubscriptiveElement[]>([]);
  public domainName = '';
  public menuFilterControl = new FormControl('');

  public budgetsLazyLoaded = false;
  public fraudsLazyLoaded = false;
  public subscriptionsLazyLoaded = false;
  public showFraudTable = false;

  public showContent = true;

  loadContent = false;
  tenantId: string;
  pre: string;
  subscriptionId: string;
  public azurePlan: GetCSPSubscription = {} as GetCSPSubscription;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  mpnList: string[] = [];
  NoMPNText = '';
  from: GetCSPSubscription = {} as GetCSPSubscription;

  billingCycle: string;

  termDuration: string;

  // loading flag group
  renewalLoading = false;
  billingLoading = false;
  qtyLoading = false;
  customEndDateLoading = false;

  editMpn: boolean = false;

  editDesc: boolean = false;

  isRenewLoaded = false;

  subscriptionDetailChanged = false;

  qtyChanged = false;

  termChanged = false;

  billingFreqChanged = false;

  updateQtyChange = false;

  customEndDateChanged = false;

  targetTerm: string;

  targetBillingFreq: string;

  cancellationAllowedUntilDate: Date;
  creationDate: string;

  qty: number;

  expiryDate: string;
  currentUser: CurrentUserModel;
  isCancelable: boolean = false;
  isRefundable: boolean = false;
  isCanceling: boolean = false;

  hasEmptyFilterResult: boolean = false;
  poReference = '';
  mceRenewalData: MCEUpgradeModel = {} as MCEUpgradeModel;
  catalogItemId = '';
  supportedBillingCycles: string[] = [];
  public scheduledNextTermInstructions: ScheduledNextTermInstructions; 
  public fraudNotificationTableDataSrc: FraudNotificationElement[] = [];
  sortedData : FraudNotificationElement[] = [];
  //annuities: FraudNotificationElement[];
  dataSource: MatTableDataSource<FraudNotificationElement>
  public displayedColumns: string[] = [
    'entityName',
   /*  'hitCount', */
    'serviceName',
    'resourceName',
    'resourceGroupName',
    'lastOccurrence',
    'actionsOne',
    'actionsTwo'
  ];
  // @Input() subscriptionId: string;

  // @Input() tenantId: string;

  public refreshing = false;
  public loading = false; 
  public subscriptionTableDataSrc: SubscriptiveElement[];
  public tableDataSrc: SubscriptiveElement[];  
  public displayedColumns1: string[] = [
    'friendlyName',
    'entitlementId',
    'status'
  ];
  public upgradeSubscriptionForm = this.fb.group({
    mpn: [{ value: '', disabled: false }],
    desc: [{ value: '', disabled: false }],
    autoRenewalEnabled: [{ value: false, disabled: true }],
    toQty: [''],
    renewal: [{ value: '', disabled: true }],
    billing: [''],
    activeSuspend: [false],
    customEndDate: []
  });
  checkOutService: any;

  public get toggleSuspendButton(): AbstractControl {
    return this.upgradeSubscriptionForm.get('activeSuspend')
  }
  @Input() set details(value: ADKDetailsViewModel) {
    this._details.next(value);
  };

  get details() {
    return this._details.getValue();
  }
  constructor(
    private manageService: ManageService,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    public commonService: CommonService,
    private router: Router,
    private fb: FormBuilder,
    public sidenavService: PanelService,
    private vcr: ViewContainerRef,
    public calendar: NgbCalendar,
    private authService: AuthService,
    private datePipe: DatePipe,
    private location: Location
  ) {
    this.NoMPNText = commonService.NoMPNText;
    let tempArr = this.router.url.split("/");
    if (tempArr.length > 8) {
      this.catalogItemId = tempArr[8];
    }
  }

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    if (!$('#budgetAlertsDetail').length && !$('#budgetAlertsEdit').length) {
      $('#levelOne').animate({ scrollLeft: $('#managecsp').width() + 505 }, 400);
    }
  }

  ngOnInit() {

    combineLatest([
      this.activatedRoute.parent.params,
      this.activatedRoute.params,
      this.manageService.currentExistingCSPSubscriptions
    ])
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(([tenantParams, subParams, subs]) => {
        this.tenantId = tenantParams['tenantId'];

        if (subParams['sub'] && this.subscriptionId != subParams['sub']) {
          this.subscriptionId = subParams['sub']

          const defaultMenu = subParams['menuTitle']
          if (defaultMenu) {
            const index = this.sideMenu.findIndex(title => {
              return title.key === defaultMenu;
            });
            if (index >= 0 ) {
              this.changeSection(index);
            } else {
              this.router.navigateByUrl('/home');
            }
          }

          this.loading = true;
          this.manageService.GetAzureEntitlements(this.tenantId.toLocaleLowerCase(), this.subscriptionId)
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe((sub: any) => {
              this.loading = false;
              this.refreshing = false;

              if (!this.commonService.isEmpty(sub)) {
                this.subscriptionTableDataSrc = sub.map(result => {
                  return {
                    entitlementId: result.entitlementId,
                    friendlyName: result.friendlyName,
                    status: result.status,
                    tenantDomain: result.tenantDomain
                  } as SubscriptiveElement
                });

                this._azureEntitlements.next(this.subscriptionTableDataSrc);

                this.tableDataSrc = sub.map(result => {
                  return {
                    entitlementId: result.entitlementId,
                    friendlyName: result.friendlyName,
                    status: result.status,
                    tenantDomain: result.tenantDomain
                  } as SubscriptiveElement
                })

              }
            }, (error: any) => {
              this.commonService.implementToast(error, 'Error');
            })
        }

        this.azurePlan = subs?.find(s => s.baseSubscription.out_subscription_id == this.subscriptionId).baseSubscription;
        if (this.azurePlan?.out_charge_type == 'MODN') {
          //this.sideMenu[4].disabled = false;
        }

        this.manageService.currentDetailsWatch.pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: ADKDetailsViewModel) => {
          if (Object.keys(response).length > 0) {
            this.details = response;
            this.domainName = this.details.customer.out_prefix;

          }
        })

        // SUBSCRIPTION DETAILS
        if (subs != null && subParams['sub'] != null) {
          let sub = subs.find(s => s.baseSubscription.out_subscription_id == subParams['sub']);
          this.from = sub.baseSubscription;
          this.mceRenewalData.from = sub.baseSubscription;
          this.upgradeSubscriptionForm.get('mpn').setValue(this.from.out_mpnid == '' ? this.NoMPNText : this.from.out_mpnid);
          this.upgradeSubscriptionForm.get('desc').setValue(this.from.out_sub_description);
          this.toggleSuspendButton.setValue(!this.from.out_activeSuspend);
          this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);
        }

        this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe(
          (user: CurrentUserModel) => {
            this.currentUser = user;
          }
        );

        // MANAGE RENEWAL 
        if (this.subscriptionId) {
          this.manageService.GetNCERenewStatus(this.tenantId.toLocaleLowerCase(), this.subscriptionId.toLocaleLowerCase())
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe((sub: string) => {
              const result = JSON.parse(sub);
              if (!this.commonService.isEmpty(result)) {
                this.displaySubDetailFromData(result);
              }
            }, (error: any) => {
              this.commonService.implementToast(error, 'Error');
            })
        };
      });

    // observe current subscription
    this.manageService.currentSoftwareSubscription.subscribe((subData: any) => {
      if (!this.commonService.isEmpty(subData)) {
        this.supportedBillingCycles = subData.supportedBillingCycles;
        let sub = subData.subscription;
        this.displaySubDetailFromData(sub);
        this.from.out_subscription_id = sub.id;
        this.from.out_expiry_date = sub.commitmentEndDate;
        this.from.out_confirmed_qty = sub.quantity;
        this.from.out_offer_uri = `${sub.termDuration}:${sub.stockCode}`;
        this.from.out_stock_code = `${sub.termDuration}:${sub.stockCode}`;
        this.from.out_status = sub.status;
        this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.from.out_confirmed_qty));
        this.billingCycle = sub.billingCycle;
        this.termDuration = sub.termDuration;

      }
    })
    this.postInit();
  }
  private loadFraudList(): void {
    if (this.tenantId) {
      this.sideMenu[2].refreshingFlag = true;
      this.showFraudTable = false;
      this.manageService.getCSPFraudAlertList_ByTenant(this.tenantId.toLocaleLowerCase())
        .pipe(takeUntil(this.ngUnsubscribe)).subscribe((sub: any) => {
          this.showFraudTable = true;
          if (!this.commonService.isEmpty(sub)) {
            this.fraudNotificationTableDataSrc = sub.map(result => {
              return {
                eventId: result.eventId,
                entityName: result.entityName,
                hitCount: result.hitCount,
                serviceName: result.serviceName,
                resourceName: result.resourceName,
                resourceGroupName: result.resourceGroupName,
                lastOccurrence: result.lastOccurrence
              } as FraudNotificationElement
            })
            this.dataSource = sub.map(result => {
              return {
                eventId: result.eventId,
                entityName: result.entityName,
                hitCount: result.hitCount,
                serviceName: result.serviceName,
                resourceName: result.resourceName,
                resourceGroupName: result.resourceGroupName,
                lastOccurrence: result.lastOccurrence
              } as FraudNotificationElement
            })
          }

          this._azureEntitlements
            .pipe(take(1))
            .subscribe(async (subs: any) => {
              const filterAtctives = subs.filter(sub => sub.status == "ACTIVE").map(sub => sub.entitlementId);

              if (filterAtctives?.length) {
                console.log('start fetching azure entitlements ......')
                const promises = filterAtctives.map(this.getSingleSubCSPFraudAlertList, this)
                await Promise.all(promises)
                console.log('finished fetching azure entitlements ......')
              }

              this.sideMenu[2].refreshingFlag = false;
              this.fraudsLazyLoaded = true;
            });


        }, (error: any) => {
          this.commonService.implementToast(error, 'Error');
        })
    }
  }

  private getSingleSubCSPFraudAlertList(subId: string): Promise<void> {
    return new Promise((resolve) => {
      this.manageService
        .getCSPFraudAlertList(subId)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((sub: any) => {
          if (!this.commonService.isEmpty(sub)) {
            this.fraudNotificationTableDataSrc.push(sub.map(result => {
              return {
                eventId: result.eventId,
                entityName: result.entityName,
                hitCount: result.hitCount,
                serviceName: result.serviceName,
                resourceName: result.resourceName,
                resourceGroupName: result.resourceGroupName,
                lastOccurrence: result.lastOccurrence
              } as FraudNotificationElement
            }))
            this.dataSource.data = this.fraudNotificationTableDataSrc;
          }
          console.log('done', subId)
          resolve();
        });
    });
  }

  public onFraudTableActionButtonEvent(eventId: string, action: string): void {
    this.dialog.open(SimpleMsgPopupComponent, {
      width: '400px',
      data: {
        showCancel: true,
        title: `Comfirm ${action}`,
        msg: `Are you sure you want to resolve as ${action}?`
      }
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.manageService.updateFraudAlertStatus(this.subscriptionId, [eventId], 'Resolved', action)
            .pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
              this.commonService.implementToast(`Successfully resolved as ${action}`, 'Success');
              this.loadFraudList();
            }, (error: any) => {
              this.commonService.implementToast(error, 'Error');
            })
        }
      });
  }

  private postInit(): void {
    this.upgradeSubscriptionForm.get('renewal')
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((term) => {
        if (term === 'P1M') {
          if (this.billingCycle == 'annual') {
            this.upgradeSubscriptionForm.get('billing').setValue('monthly')
          } else {
            this.upgradeSubscriptionForm.get('billing').setValue('')
          }
        }
        if (term) {
          this.termChanged = this.termDuration !== term;
          this.targetTerm = term;
        } else {
          this.termChanged = false;
        }
      })

    this.upgradeSubscriptionForm.get('billing')
      .valueChanges.pipe(takeUntil(this.ngUnsubscribe)).subscribe((term) => {
        if (term) {
          this.billingFreqChanged = this.billingCycle !== term;
          this.targetBillingFreq = term;
        } else {
          this.billingFreqChanged = false;
        }
      })

    this.manageService.currentMPNList.pipe(takeUntil(this.ngUnsubscribe)).subscribe((mpns) => {
      this.mpnList = mpns;
    })
  }

  toggleMPNChange() {
    this.editMpn = !this.editMpn;
  }

  toggleDescChange() {
    this.editDesc = !this.editDesc;
  }

  filterAzureSubscriptions() {
    var result = [];
    var filteredResult = [];
    if (this.searchField.length == 0) {
      this.tableDataSrc = this.subscriptionTableDataSrc;
    }
    else {
      this.tableDataSrc = this.subscriptionTableDataSrc.filter(x => x.entitlementId.toLowerCase().
        includes(this.searchField.toLowerCase()) || x.friendlyName.toLowerCase().
          includes(this.searchField.toLowerCase()) || x.status.toLowerCase().includes(this.searchField.toLowerCase()));
    }
  }
  updateSubscriptionDetails() {
    this.confirmChange();
  }

  displaySubDetailFromData(sub: any) {
    this.isRenewLoaded = true;
    this.scheduledNextTermInstructions = sub.scheduledNextTermInstructions;
    this.mceRenewalData.autoRenewalEnabled = sub.autoRenewEnabled;
    this.upgradeSubscriptionForm.get('autoRenewalEnabled').setValue(this.mceRenewalData.autoRenewalEnabled)
    this.billingCycle = this.mceRenewalData.billingCycle = sub.billingCycle;
    this.termDuration = this.mceRenewalData.termDuration = sub.termDuration;
    this.cancellationAllowedUntilDate = new Date(sub.cancellationAllowedUntilDate);
    this.qty = sub.quantity;
    this.upgradeSubscriptionForm.get('toQty').setValue(Number(this.qty));
    this.mceRenewalData.changeToQty = Number(this.qty);
    this.expiryDate = sub.commitmentEndDate;
    this.creationDate = sub.creationDate;
    let today = new Date();
    this.isCancelable = !this.commonService.isEmpty(sub.refundableQuantity) ? (sub.quantity - sub.refundableQuantity.totalQuantity == 0) : this.cancellationAllowedUntilDate > today;
    this.manageService.monitorMCESubscriptionUpgrade(this.mceRenewalData);

    const customEndDate = new Date(sub.commitmentEndDate)
    const date = { day: customEndDate.getUTCDate(), month: customEndDate.getUTCMonth() + 1, year: customEndDate.getUTCFullYear() };
    this.upgradeSubscriptionForm.get('customEndDate').setValue(date);
  }

  confirmChange(): void {

    const dialogRef = this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title: "Confirm Subscription Details", text: `Are you sure to change the subscription details` }
    });

    dialogRef.afterClosed().subscribe((res) => {

      if (res) {

        let confirmSubscriptions: CSPModifySubscriptionViewModel[] = [];

        let confirmBaseSubscription = {} as CSPModifySubscriptionViewModel;

        confirmBaseSubscription = {
          tenantId: this.from.out_tenant_id,
          mpnId: this.upgradeSubscriptionForm.get('mpn').value == this.NoMPNText ? '' : this.upgradeSubscriptionForm.get('mpn').value,
          subscriptionId: this.from.out_subscription_id,
          subscriptionDescription: this.upgradeSubscriptionForm.get('desc').value,
          customerReference: this.poReference,
          stockDescription: this.from.out_stk_description,
          parentSubscriptionId: this.from.out_parent_subscription,
          stockCode: this.from.out_stock_code,
          qty: this.from.out_qty,
          status: '',
          ownerEmail: this.from.out_default_email,
          price: this.from.out_price,
          totalPrice: this.from.out_amount,
          billingFrequency: this.from.out_billing_freq,
          chargeType: this.from.out_charge_type
        };

        confirmSubscriptions.push(confirmBaseSubscription);

        if ((this.upgradeSubscriptionForm.get('mpn').value == this.NoMPNText) || (this.upgradeSubscriptionForm.get('mpn').value == this.from.out_mpnid)) {

          this.editMpn = this.editDesc = true;

          this.upgradeSubscriptionForm.get('desc').disable();

          const dialogRef = this.dialog.open(ConfirmSubscriptionComponent, {
            width: '650px',
            data: { totalPriceChange: 0, pendingTotal: 0, hasNCE: true }
          });

          dialogRef.afterClosed().subscribe(result => {

            if (result) {
              this.poReference = result;
              this.manageService.createOrUpdateCSPSubscription(confirmSubscriptions).subscribe((res) => {
                // this.editMpn = false;
                // this.manageService.refetchCSPItemsView$.next();
                let finishSubscriptions = res;
                this.loadContent = true;
                const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
                  width: '650px',
                  data: { finishSubscriptions: finishSubscriptions },
                  disableClose: true
                });

                dialogRefFinish.afterClosed().subscribe(() => {
                  this.editMpn = this.editDesc = false;
                  this.upgradeSubscriptionForm.get('desc').enable();
                  this.upgradeSubscriptionForm.get('mpn').enable();
                  this.manageService.refetchCSPItemsView$.next();
                })
              });
            }
          })

        } else {

          this.editMpn = this.editDesc = true;

          this.upgradeSubscriptionForm.get('desc').disable();
          this.upgradeSubscriptionForm.get('mpn').disable();
          this.manageService.GetPartnerByMPNId(confirmBaseSubscription.mpnId).subscribe((res: MnpIdAipiResponse) => {
            if (res.result === 'Success') {
              this.commonService.implementToast('Verifying Microsoft Partner Agreement Status ...', 'Info');
              this.manageService.GetMPAStatusByMPNId(confirmBaseSubscription.mpnId).subscribe((result: MnpIdAipiResponse) => {
                if (result.status === false) {
                  this.commonService.implementToast('Please check Microsoft Partner Agreement status with partner_id ' + confirmBaseSubscription.mpnId, 'Error', true);
                  this.editMpn = false;

                } else {

                  const dialogRef = this.dialog.open(ConfirmSubscriptionComponent, {
                    width: '650px',
                    data: { totalPriceChange: 0, pendingTotal: 0, hasNCE: true }
                  });

                  dialogRef.afterClosed().subscribe(result => {

                    if (result) {
                      this.poReference = result;
                      this.manageService.createOrUpdateCSPSubscription(confirmSubscriptions).subscribe((res) => {
                        let finishSubscriptions = res;
                        const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
                          width: '650px',
                          data: { finishSubscriptions: finishSubscriptions },
                          disableClose: true
                        });

                        dialogRefFinish.afterClosed().subscribe(() => {
                          this.editMpn = this.editDesc = false;
                          this.upgradeSubscriptionForm.get('desc').enable();
                          this.upgradeSubscriptionForm.get('mpn').enable();
                          this.manageService.refetchCSPItemsView$.next();
                        })
                      });
                    } else {
                      this.upgradeSubscriptionForm.get('desc').enable();
                      this.upgradeSubscriptionForm.get('mpn').enable();
                    }
                  })
                }
              })
            } else {
              this.commonService.implementToast('Invalid MPN ID', 'Error');
              this.editMpn = this.editDesc = false;
              this.upgradeSubscriptionForm.get('desc').enable();
              this.upgradeSubscriptionForm.get('mpn').enable();
            }
          });
        }
      }
    });
  }

  showAutoCompletePanel(trigger: any): void {
    trigger.openPanel();
  }

  getRenewDate() {
    let renew_date = '';
    if (this.expiryDate) {
      let renewalDate = new Date(this.expiryDate);
      renewalDate.setDate(renewalDate.getDate() + 1);
      renew_date = format(renewalDate, 'dd-MMM-yyyy');
    }
    return renew_date.toUpperCase();
  }

  getTermDuration(subscription: GetCSPSubscription): string {
    let term: string;
    if (subscription.out_target_term) {
      term = subscription.out_target_term;
    } else {
      term = subscription.out_stock_code.split(":")[0].toUpperCase();
    }
    return term;
  }

  getAutoRenwewalText(autoRenewalEnabled: boolean): string {
    if (autoRenewalEnabled) {
      let renewalDate = new Date(this.expiryDate);
      renewalDate.setDate(renewalDate.getDate() + 1);
      return `RENEWS ON ${format(renewalDate, 'dd-MMM-yyyy')}`
    } else {
      return `EXPIRY ON ${format(new Date(this.expiryDate), 'dd-MMM-yyyy')}`
    }
  }

  isSubInProgress(): boolean {
    return !this.commonService.isEmpty(this.from) && this.from.out_status_desc && this.from.out_status_desc.includes('In Progress')
  }
  onQtyTyping(event: any) {
    if (event.key < 0 && event.target.value == "") {
      event.preventDefault();
    }
  }
  formatDateTime(vdate: any) {
    return format(new Date(vdate), 'dd-MMM-yyyy HH:mm');
  }

  cancelSubscription(subscription: GetCSPSubscription) {
    this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: {
        title: 'Confirm Cancellation', text: 'Are you sure to cancel this subscription?',
        cancelMessage: ' If you cancel the subscription within 7 days, you will be refunded for any time you have not used. A credit will appear in your next monthly invoice. The customer will lose access to this subscription immediately upon cancellation and access can’t be restored after cancellation.'
      }
    }).afterClosed().subscribe(result => {
      if (result) {
        this.isCanceling = true;
        this.manageService.CancelSubscription(this.tenantId.toLocaleLowerCase(), subscription.out_subscription_id.toLocaleLowerCase(), subscription.out_stock_code.toLocaleLowerCase(), subscription.out_offer_uri.toLocaleLowerCase(), subscription.out_expiry_date ? subscription.out_expiry_date : '').subscribe(() => {

          this.isCanceling = false;
          this.manageService.refetchCSPItemsView$.next();
          this.close();
        },
          (error: any) => {
            this.isCanceling = false;

            this.commonService.implementToast(error, "Error")
          });
      }
    });
  }

  public toggleSuspendHandler(): void {
    // prepare texts for popup display
    const status = this.toggleSuspendButton.value ? 'XX' : 'PR';
    const title = this.toggleSuspendButton.value ? "Confirm Suspension" : "Confirm Activate";
    const text = `This will ${this.toggleSuspendButton.value ? 'suspend' : 'activate'} service, you will continue to accrue charges as per this subscriptions existing commitment. Additional commitments will also accrue if auto-renew is still enabled`;

    if (this.toggleSuspendButton.value) {
      this.from.out_status_desc = 'Suspend Pending';
    }
    else {
      this.from.out_status_desc = 'Reactivation Pending';
    }

    // show confirm popup
    this.dialog.open(ConfirmNCESubscriptionComponent, {
      width: '650px',
      data: { title, text }
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          const confirmSub = {
            tenantId: this.from.out_tenant_id,
            mpnId: this.commonService.parseNPM(this.from.editMpnIdValue),
            subscriptionId: this.from.out_subscription_id,
            subscriptionDescription: this.from.out_sub_description,
            customerReference: '',
            stockDescription: this.from.out_stk_description,
            parentSubscriptionId: this.from.out_parent_subscription,
            stockCode: this.from.out_stock_code,
            qty: this.from.out_qty,
            status,
            ownerEmail: this.from.out_default_email,
            price: this.from.out_price,
            totalPrice: this.from.out_amount,
            billingFrequency: this.from.out_billing_freq
          } as CSPModifySubscriptionViewModel;

          this.loadContent = false;
          this.manageService.createOrUpdateCSPSubscription([confirmSub]).subscribe((res: CSPModifySubscriptionResponse[]) => {
            if (res.length) {
              const finishSubscriptions = res;
              this.loadContent = true;
              const dialogRefFinish = this.dialog.open(FinishSubscriptionComponent, {
                width: '650px',
                data: { finishSubscriptions: finishSubscriptions },
                panelClass: 'mat-dialog-wrapper',
                disableClose: true
              });

              dialogRefFinish.afterClosed().subscribe(() => {
                this.manageService.refetchCSPItemsView$.next();
              }, (error: any) => {
                this.commonService.implementToast(error, 'Error');
              }
              );
            }
          });
        } else {
          // if user cancel the popup window we need to set the toggle back
          this.toggleSuspendButton.setValue(!this.toggleSuspendButton.value)
          if (this.toggleSuspendButton.value) {
            this.from.out_status_desc = 'Suspended';
          }
          else {
            this.from.out_status_desc = 'Active';
          }
        }
      })
  }

  public isActive(index: number): boolean {
    return this.currentMenuIndex == index;
  }

  public changeSection(index: number): void {
    this.showContent = true;
    switch (index) {
      case 2:
        if (!this.fraudsLazyLoaded) {
          this.loadFraudList();
        }
        break;
      case 3:
        this.budgetsLazyLoaded = true;
        break;
     /*  case 4:
        this.subscriptionsLazyLoaded = true;
        break; */
    }
    const prefix = 'ManageAzureSubscription/';
    const cururl = this.location.path().replace(prefix + this.sideMenu[this.currentMenuIndex]?.key, prefix + this.sideMenu[index]?.key);
    this.currentMenuIndex = index;
    this.location.go(cururl);
  }

  public refreshFraudNotifications(): void {
    this.sideMenu[2].refreshingFlag = true;
    this.loadFraudList();
  }

  close() {
    this.manageService.sendCurrentSoftwareSubscription(null);
    this.manageService.backToTenentPage(this.tenantId);
  }

  public createSubscription(): void {
    this.dialog.open(ConfirmMASSubCreationPopup, {
      width: '400px',
      data: {
        tenantId: this.tenantId,
        subscriptionId: this.subscriptionId
      }
    })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.ngOnInit();
        }
      });
  }

  public refresh(): void {
    this.refreshing = true;
    this.ngOnInit();
  }

  public closeBody(): void {
    this.showContent = false;
  }
  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    if (this.sidenavService?.panel?.opened) {
      this.sidenavService.panel.close()
    }
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  
  matSortData(sort: Sort) {
    const data = this.fraudNotificationTableDataSrc.slice();
    if (!sort.active || sort.direction === "") {
      this.fraudNotificationTableDataSrc = data;
      this.dataSource.data = this.fraudNotificationTableDataSrc;
      return;
    }
    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "entityName":
          return compare(
            a.entityName.toLowerCase(),
            b.entityName.toLowerCase(),
            isAsc
          );
        /* case "hitCount":
          return compare(
            a.hitCount,
            b.hitCount,
            isAsc
          ); */
        case "serviceName":
          return compare(
            a.serviceName.toLowerCase(),
            b.serviceName.toLowerCase(),
            isAsc
          );

        case "resourceGroupName":
          return compare(
            a.resourceGroupName.toLowerCase(),
            b.resourceGroupName.toLowerCase(),
            isAsc
          );
        case "resourceName":
          return compare(
            a.resourceName.toLowerCase(),
            b.resourceName.toLowerCase(),
            isAsc
          );
        case "lastOccurrence":
          return compare(
            a.lastOccurrence.toLowerCase()
            ,
            b.lastOccurrence.toLowerCase()
            ,
            isAsc
          );
        default:
          return 0;
      }
    });
    this.dataSource = new MatTableDataSource(this.sortedData);
  }

}

export interface FraudNotificationElement {
  entityName: string;
  hitCount: number;
  serviceName: string;
  resourceName: string;
  resourceGroupName: string;
  lastOccurrence: string;
}

export interface sideMenuElement {
  key: string;
  displayName: string;
  tabIndex: number;
  disabled: boolean;
  refreshingFlag: boolean;
}

export interface SubscriptiveElement {
  entitlementId: string;
  friendlyName: string;
  status: string;
  tenantDomain: string;
}
function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

